import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import style from './style.css'

import { Modal } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import closeIcon from 'Assets/x-icon-gray.svg'

export default function SampleAssignmentDialogModal (props) {
  return (
    <div>
      <Modal show={true} dialogClassName={classnames(style.mobileModal)}>
        <Modal.Body className={style.container}>
          <div>
            <Row>
              <Col xs={10}>
                <h2 className={style.sampleModalHeader}>
                  Student Preview
                </h2>
              </Col>
              <Col xs={2}>
                <button
                  data-test-id="hideSampleDataBtn"
                  aria-label="Close Sample Activities"
                  className={classnames(style.hideSampleActivities)}
                  onClick={props.onCancel}
                  tabIndex="0"
                >
                  <object
                    data={closeIcon} type="image/svg+xml"
                    className={style.svgIcon}
                    tabIndex="-1"
                  />
                </button>
              </Col>
            </Row>
            <Row><Col><hr /></Col></Row>
            <p>
              This option will take the student to a report that shows his or her performance
              across all Read & Practice activities he or she has started or completed in the course.
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

SampleAssignmentDialogModal.propTypes = {
  onCancel: PropTypes.func.isRequired
}
